export const firebaseConfig = {
    apiKey: "AIzaSyCHisYloYg1zWs_OgFcCiyo99RBaCwa19c",
    authDomain: "laaa-299813.firebaseapp.com",
    databaseURL: "https://laaa-299813-default-rtdb.firebaseio.com",
    projectId: "laaa-299813",
    storageBucket: "laaa-299813.appspot.com",
    messagingSenderId: "468934242001",
    appId: "1:468934242001:web:8e9529442944f5ad141ff0",
    measurementId: "G-L09RY326LB"
};